import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import { usePresentation } from '../../contexts/PresentationContext';

export default function AppLayout({ children }) {
  const [menuAberto, setMenuAberto] = useState(false);
  const navigate = useNavigate();
  const { apresentacaoAtiva, hospitaisPermitidos, sairApresentacao } = usePresentation();

  const sairEVoltarParaSelecaoDeModo = () => {
    sairApresentacao();
    navigate('/modo-exibicao', { replace: true });
  };

  return (
    <div className="app-shell">
      <div className="app-topbar-mobile">
        <button
          type="button"
          className="app-topbar-mobile__botao"
          onClick={() => setMenuAberto(true)}
          title="Abrir menu"
        >
          <span className="ms">menu</span>
        </button>
        <span className="app-topbar-mobile__marca">AM Gestão</span>
      </div>

      {menuAberto && <div className="app-shell__backdrop" onClick={() => setMenuAberto(false)} />}

      <Sidebar abertoMobile={menuAberto} onFecharMobile={() => setMenuAberto(false)} />
      <main className="app-main">
        {apresentacaoAtiva && (
          <div className="apresentacao-banner">
            <span className="ms">present_to_all</span>
            <span>
              Modo Apresentação — {hospitaisPermitidos.length} hospital(is) selecionado(s), os demais estão ocultos
            </span>
            <button type="button" onClick={sairEVoltarParaSelecaoDeModo}>
              Sair do modo apresentação
            </button>
          </div>
        )}
        {children}
      </main>
    </div>
  );
}
